import React from 'react';
import tabify from 'shared/containers/tabify';
import cx from 'classnames';

const ReferralTabs = tabify(({ children, tabs, setActiveTabName, span }) => (
  <div>
    <ul
      data-spec-id="referral-tab-nav"
      className="nav nav-tabs second-layer-nav-tabs"
      style={{ clear: 'left', marginBottom: '0px' }}
    >
      {tabs.map(tab => {
        const navItemClasses = cx({ active: tab.active });
        return (
          <li key={tab.name} className={navItemClasses}>
            <span className="fake-link nav-tabs__tab" onClick={tab.onClick}>
              {tab.name} {tab.extraNavContent}
            </span>
          </li>
        );
      })}
    </ul>
    <div className="tab-content second-layer-tab-content">{children}</div>
  </div>
));

export default ReferralTabs;
